import React, { Component } from 'react'
import { JDRouter } from '@jdreact/jdreact-core-lib'

const { Router, Route } = JDRouter;

import DetailsPage from './pages/DetailsPage'
import HouseDes from "./pages/DetailsPage/HouseDes";
import BrokerInfo from "./pages/DetailsPage/BrokerInfo";
import ShopMap from "./pages/DetailsPage/ShopMap";

import Zufang from "./pages/zufang";
import ZufangList from "./pages/zufang/zufangList";
import ZufangDetail from "./pages/zufang/zufangDetail";


// 不显示黄屏提示
console.disableYellowBox = true;

class Navigator extends Component {
  render() {
    return (
      <Router initRoute={this.props.initRoute}>
        <Route key="detailsPage" component={DetailsPage} type="push" />
        <Route key="houseDes" component={HouseDes} type="push" />
        <Route key="brokerInfo" component={BrokerInfo} type="push" />
        <Route key="shopMap" component={ShopMap} type="push" />

        <Route key="zufang" component={Zufang} type="push" />
        <Route key="zufangList" component={ZufangList} type="push" />
        <Route key="zufangDetail" component={ZufangDetail} type="push" />
      </Router>
    )
  }
}

export default Navigator
